import { Controller } from 'stimulus'
import { updateCart } from '~/site/pages/cart/common'
export default class extends Controller {
  updateCart() {
    updateCart()
  }
}
